import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Divider,
  TimePicker,
  Radio,
  Input,
  Flex,
  Checkbox,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { getStockItems } from '../../../network/materialRequest';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import {
  addLeaveType,
  getLeaveTypeDetails,
  updateLeaveType,
} from '../../../network/leaveType';
import HeadingApp from '../../../hooks/HeadingApp';
import { LuClipboardType } from 'react-icons/lu';
const LeaveTypeAdd = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const { companyName, currentLang } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const watchis_earned_leave = Form.useWatch('is_earned_leave', form);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddStockEntry } = useMutation({
    mutationKey: ['addStockEntry'],
    mutationFn: (body) =>
      edit ? updateLeaveType(body, id) : addLeaveType(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getEmployee] });
      form.resetFields();
      navigate('/leave-type');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const { data: employeeDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getLeaveType, id],
    queryFn: () => getLeaveTypeDetails(id),
    enabled: !!edit,
  });
  useEffect(() => {
    if (edit && employeeDetails) {
      form.setFieldsValue({
        ...employeeDetails?.data,
      });
    } else {
      form.resetFields();
    }
  }, [edit, employeeDetails, form]);
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddStockEntry({
      ...values,
      is_carry_forward: values?.is_carry_forward ? 1 : 0,
      is_lwp: values?.is_lwp ? 1 : 0,
      is_ppl: values?.is_ppl ? 1 : 0,
      allow_negative: values?.allow_negative ? 1 : 0,
      include_holiday: values?.include_holiday ? 1 : 0,
      is_earned_leave: values?.is_earned_leave ? 1 : 0,
    });
  };
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.HR}
        subTitle={edit ? t.EditLeaveType : t.AddLeaveType}
        path="/leave-type"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.LeaveType}
        subTitle={edit ? t.EditLeaveType : t.AddLeaveType}
        icon={<LuClipboardType />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-leave-type"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="leave_type_name"
                    label={t.leaveTypeName}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.leaveTypeName} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="max_leaves_allowed"
                    label={t.maxLeavesAllowed}
                  >
                    <Input type="number" placeholder={t.maxLeavesAllowed} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="applicable_after" label={t.applicableAfter}>
                    <Input
                      type="number"
                      placeholder={t.applicableAfter}
                      min={0}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="max_continuous_days_allowed"
                    label={t.maxContinuousDaysAllowed}
                  >
                    <Input
                      type="number"
                      placeholder={t.maxContinuousDaysAllowed}
                      min={0}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="fraction_of_daily_salary_per_leave"
                    label={t.fractionOfDailyWagePerLeave}
                  >
                    <Input
                      type="number"
                      placeholder={t.fractionOfDailyWagePerLeave}
                      max={100}
                      min={0}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="maximum_carry_forwarded_leaves"
                    label={t.maximumCarryForwardedLeaves}
                  >
                    <Input
                      type="number"
                      placeholder={t.maximumCarryForwardedLeaves}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="expire_carry_forwarded_leaves_after_days"
                    label={t.expireCarryForwardedLeavesAfterDays}
                  >
                    <Input
                      type="number"
                      placeholder={t.expireCarryForwardedLeavesAfterDays}
                    />
                  </Form.Item>
                </Col>
                {watchis_earned_leave ? (
                  <>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="earned_leave_frequency"
                        label={t.earnedLeaveFrequency}
                        initialValue="Monthly"
                      >
                        <Select>
                          <Select.Option value="Monthly">
                            {t.Month}
                          </Select.Option>
                          <Select.Option value="Quarterly">
                            {t.Quarter}
                          </Select.Option>
                          <Select.Option value="Half-Yearly">
                            {t.HalfYear}
                          </Select.Option>
                          <Select.Option value="Yearly">{t.Year}</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="allocate_on_day"
                        label={t.allocateOnDay}
                        initialValue="First Day"
                      >
                        <Select placeholder={t.allocateOnDay}>
                          <Select.Option value="First Day">
                            {t.firstDay}
                          </Select.Option>
                          <Select.Option value="Last Day">
                            {t.lastDay}
                          </Select.Option>
                          <Select.Option value="Date of Joining">
                            {t.dateOfJoining}
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="rounding"
                        label={t.rounding}
                        initialValue=""
                      >
                        <Select>
                          <Select.Option value=""></Select.Option>
                          <Select.Option value="0.25">0.25</Select.Option>
                          <Select.Option value="0.5">0.5</Select.Option>
                          <Select.Option value="1.0">1.0</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </>
                ) : null}
                <Divider />
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="is_carry_forward" valuePropName="checked">
                    <Checkbox>Is Carry Forward</Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="is_lwp" valuePropName="checked">
                    <Checkbox>{t.Areyouwithoutsalary}</Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="is_ppl" valuePropName="checked">
                    <Checkbox>{t.Partiallypaidleave}</Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="allow_negative" valuePropName="checked">
                    <Checkbox>{t.AllowNegativeBalance}</Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="include_holiday" valuePropName="checked">
                    <Checkbox>{t.Includedholidaysandvacations}</Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="is_earned_leave" valuePropName="checked">
                    <Checkbox>{t.Earnedleave}</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.Cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default LeaveTypeAdd;
